import { render, staticRenderFns } from "./TagCampaign.vue?vue&type=template&id=6fbfcd92"
import script from "./TagCampaign.vue?vue&type=script&lang=js"
export * from "./TagCampaign.vue?vue&type=script&lang=js"
import style0 from "./TagCampaign.vue?vue&type=style&index=0&id=6fbfcd92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports